<h1 class="titulo">Histórico</h1>

<div class="historico-container">
  <div class="historico-header">
    <div class="historico-titulo">
      Histórico de Registros
    </div>
    <div class="historico-descripcion">
      Por favor selecciona el año para obtener el histórico
    </div>
  </div>

  <div class="filtro-container">
    <div class="select-grupo">
      <label class="select-label">Año:</label>
      <nz-select 
        [(ngModel)]="anioSeleccionado"
        nzPlaceHolder="Seleccionar año"
        nzAllowClear
        style="width: 200px;"
        class="anio-select"
        (ngModelChange)="onAnioSeleccionado($event)">
        <nz-option 
          *ngFor="let anio of anios" 
          [nzValue]="anio" 
          [nzLabel]="anio.toString()+''">
        </nz-option>
      </nz-select>
    </div>
  </div>

  <div class="boton-container" *ngIf="anioSeleccionado">
    <button 
      nz-button 
      [disabled]="generarExcel"
      nzType="primary"
      class="boton-descargar"
      (click)="descargarHistorico()">
      <i nz-icon nzType="download"></i>
      Descargar Histórico
    </button>
  </div>
</div>
